var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 43,
    viewBox: "0 0 62 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9219 15.7363C36.2508 7.33548 40.925 3.14111 44.9473 3.14111C50.9824 3.14111 54.7935 9.8189 57.0175 18.8836C59.1418 27.5408 58.5262 39.3514 50.9824 39.3514C47.6209 39.3514 42.992 34.629 38.4657 28.3314C35.5856 24.3631 33.0612 20.1483 30.9219 15.7363Z",
    stroke: "#FAFAFA",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9222 15.7363C25.5933 7.33548 20.9191 3.14111 16.8968 3.14111C10.8617 3.14111 7.05058 9.8189 4.82667 18.8836C2.70233 27.5408 3.3179 39.3514 10.8617 39.3514C14.2232 39.3514 18.8521 34.629 23.3784 28.3314C26.396 24.134 28.9096 19.9337 30.9222 15.7363Z",
    stroke: "#FAFAFA",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeta);
export default __webpack_public_path__ + "static/media/meta.2a6e77f9b0a6eaec5c069132bb5035b3.svg";
export { ForwardRef as ReactComponent };